import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'
import { unescape } from 'lodash-es'

function deepUnescape(data: any): any {
  if (typeof data === 'string') {
    return unescape(data)
  }
  if (Array.isArray(data)) {
    return data.map((item) => deepUnescape(item))
  }
  if (data !== null && typeof data === 'object') {
    const result: any = {}
    for (const key of Object.keys(data)) {
      result[key] = deepUnescape(data[key])
    }
    return result
  }
  return data
}

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data'
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    let url = config.url as string
    url += '?'
    const keys = Object.keys(config.params)
    for (const key of keys) {
      if (config.params[key] !== void 0 && config.params[key] !== null) {
        url += `${key}=${encodeURIComponent(config.params[key])}&`
      }
    }
    url = url.substring(0, url.length - 1)
    config.params = {}
    config.url = url
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    // If it is a file flow, pass it directly
    return response
  } else if (response.data.code === SUCCESS_CODE || response.data.code === 200) {
    response.data = deepUnescape(response.data)
    if (Array.isArray(response.data.data)) {
      response.data.data = response.data.data.map((item, idx) => {
        if (typeof item === 'object' && !Array.isArray(item)) {
          return { rno: idx + 1, ...item, chk: false }
        }
      })
    }
    return response.data
  } else {
    ElMessage.error(response?.data?.message)
    if (response?.data?.code === 401) {
      const userStore = useUserStoreWithOut()
      userStore.logout()
    }
  }
}

export { defaultResponseInterceptors, defaultRequestInterceptors }
